export default __webpack_public_path__ + "static/media/circle3.cb925690.svg";